import { apiUrl } from "../Constants";
import api from "./ApiService";

const BASE_URL = apiUrl + "/api/address"

export function getAllProvince() {
  return api.get(`${BASE_URL}/provinces`)
}

export function getAllDistricts() {
  return api.get(`${BASE_URL}/all-districts`)
}

export function getAllSubDistricts() {
  return api.get(`${BASE_URL}/all-subDistricts`)
}
